import {
  Role,
  hasRightsOver,
  isAdmin,
  isSuperAdmin,
} from "@linkfluence/models/role";
import { isRoot } from "@radarly/models/level";
import { User } from "@radarly/models/user";

const isRoleAtLeast = (targetRole: Role) => (user: User, role: Role) =>
  isRoot(user.level) || hasRightsOver(role, targetRole);

// Query
export function canEditQuery(
  user: User,
  role: Role,
  superAdminOnly: boolean = true
) {
  return (
    isRoot(user.level) ||
    isSuperAdmin(role) ||
    (!superAdminOnly && isAdmin(role))
  );
}
export const canChangeQueryEditRight = isRoleAtLeast(Role.Supervisor);
export const canCreateQuery = isRoleAtLeast(Role.Admin);

// User
export const canSeeUsersTab = isRoleAtLeast(Role.Admin);
export const canRemoveSuperadmin = isRoleAtLeast(Role.Supervisor);
export const canRemoveUser = isRoleAtLeast(Role.Admin);
export const canEditUser =
  (user: User, role: Role) => (editUserId: number, editUserRole: Role) => {
    if (isRoot(user.level)) {
      return true;
    }
    const isSelfEdit = user.id === editUserId;
    return !isSelfEdit && hasRightsOver(role, editUserRole);
  };

// Blacklist Queries
export const canSeeBlacklistTab = isRoleAtLeast(Role.Admin);
